export default {
  submit: "提交",
  save: "保存",
  "submit.ok": "提交成功",
  "save.ok": "保存成功",
};
